(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("contrast-light", [], factory);
	else if(typeof exports === 'object')
		exports["contrast-light"] = factory();
	else
		root["SurveyTheme"] = root["SurveyTheme"] || {}, root["SurveyTheme"]["ContrastLight"] = factory();
})(this, () => {
return 